import axios from 'axios'
import { forcedError, shouldForceError } from '../utils/devErrors'

// Get the API URL from environment variables or default to localhost
let API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000'
// Get the API key from environment variables
const API_KEY = process.env.REACT_APP_API_KEY

if (!API_URL.includes('localhost')) {
  API_URL = API_URL + '/api'
}

// Create a reusable axios instance with default config
const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-API-Key': API_KEY || '',
  },
})

// Dev-only: when the force-errors flag is set, reject matching requests so error
// states can be inspected. No-op unless explicitly enabled (see utils/devErrors).
apiClient.interceptors.request.use(config => {
  if (shouldForceError(config.url)) {
    return Promise.reject(forcedError())
  }
  return config
})

export default apiClient
